import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drawer-accordion__caret-wrapper" }
const _hoisted_2 = { class: "drawer-accordion__title typographies-paragraph-caps-small-bold" }

import { ref, computed, onMounted, onBeforeUnmount, nextTick, useTemplateRef } from 'vue';
import LocalStorage from 'Core/commons/LocalStorage';

interface DrawerAccordionProps {
    title: string;
    id: string;
    openByDefault?: boolean;
    coloredIcon?: string;
    hasError?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerAccordion',
  props: {
    title: {},
    id: {},
    openByDefault: { type: Boolean, default: false },
    coloredIcon: { default: 'pig-money' },
    hasError: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const localstorage: InstanceType<typeof LocalStorage> = new LocalStorage('drawer', 'accordion');

const isOpen = ref<boolean>(true);
const contentHeight = ref<number>(0);
const observer = ref<ResizeObserver | null>(null);

const accordionContent = useTemplateRef<HTMLElement>('accordionContent');
const accordionContentWrapper = useTemplateRef<HTMLElement>('accordionContentWrapper');

const classes = computed<string[]>(() => [
    'drawer-accordion',
    isOpen.value ? 'drawer-accordion--open' : '',
    props.hasError ? 'drawer-accordion--error' : '',
]);

const coloredIconColor = computed<string>(() => {
    if (props.hasError) {
        return CompassEnums.ColoredIconColorType.RED;
    }
    return isOpen.value
        ? CompassEnums.ColoredIconColorType.BRAND
        : CompassEnums.ColoredIconColorType.GRAY;
});

const contentMaxHeight = computed<string>(
    () => `max-height: ${isOpen.value ? contentHeight.value : 0}px;`,
);

const setContentHeight = (): void => {
    if (accordionContent.value) {
        contentHeight.value = accordionContent.value.scrollHeight;
    }
};

const handleClick = (): void => {
    isOpen.value = !isOpen.value;
    // Accept any object, but only set boolean for our id
    const raw = localstorage.get();
    const storedValues: Record<string, unknown> = raw && typeof raw === 'object' ? raw : {};
    storedValues[props.id] = isOpen.value;
    localstorage.set({ ...storedValues });
};

const initObserver = (): void => {
    if (!accordionContentWrapper.value) return;
    const resizeObserver = new ResizeObserver(setContentHeight);
    resizeObserver.observe(accordionContentWrapper.value);
    observer.value = resizeObserver;
};

onMounted(() => {
    const storedValues = localstorage.get() as Record<string, boolean> | null;
    isOpen.value = storedValues?.[props.id] ?? props.openByDefault ?? true;
    initObserver();
    nextTick(() => {
        setContentHeight();
    });
});

onBeforeUnmount(() => {
    if (observer.value && accordionContentWrapper.value) {
        observer.value.unobserve(accordionContentWrapper.value);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_CompassIcon = _resolveComponent("CompassIcon")!
  const _component_CompassColoredIcon = _resolveComponent("CompassColoredIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classes.value)
  }, [
    _createElementVNode("div", {
      class: "drawer-accordion__head",
      onClick: handleClick
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CompassIcon, {
          icon: "caret-right-fill",
          size: "extra-small",
          class: "drawer-accordion__caret"
        })
      ]),
      _createVNode(_component_CompassColoredIcon, {
        icon: __props.coloredIcon,
        color: coloredIconColor.value
      }, null, 8 /* PROPS */, ["icon", "color"]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */),
      (props.hasError)
        ? (_openBlock(), _createBlock(_component_CompassIcon, {
            key: 0,
            class: "drawer-accordion__error-icon",
            icon: "error-circle-fill",
            size: _ctx.CompassEnums.IconSize.SMALL
          }, null, 8 /* PROPS */, ["size"]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "action")
    ]),
    _createElementVNode("div", {
      ref_key: "accordionContent",
      ref: accordionContent,
      class: "drawer-accordion__content",
      style: _normalizeStyle(contentMaxHeight.value)
    }, [
      _createElementVNode("div", {
        ref_key: "accordionContentWrapper",
        ref: accordionContentWrapper,
        class: "drawer-accordion__content-wrapper"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512 /* NEED_PATCH */)
    ], 4 /* STYLE */)
  ], 2 /* CLASS */))
}
}

})